module.exports = __webpack_public_path__ + "img/Bg_03.06e8a2a7.png";